/**
 * Builds title/mobileTitle/route/imgAlt resolvers for a navbar tree.
 *
 * `isResolved` is a single per-render flag — true when the tree came from
 * Payload (already localized), false for the static config (i18n keys
 * needing `t()`). The branch is made once here, so `renderLinks`
 * (navigation.js) just calls e.g. `resolvers.title(link)` for every node
 * without re-checking `isResolved` per field per node.
 *
 * @param {(key: string) => string} t - i18next translate function
 * @param {boolean} isResolved
 */
export const createNavResolvers = (t, isResolved) => {
  if (isResolved) {
    return {
      title: (link) => link.title,
      mobileTitle: (link) => link.mobileTitle || '',
      imgAlt: (link) => link.imgAlt || '',
      // A CMS-resolved link's route is already the final value — no
      // isExternal/absolute-path special-casing needed (that's only for
      // disambiguating raw i18n keys from real paths in the static case).
      route: (link) => (link?.route ? link.route : undefined),
    };
  }

  return {
    title: (link) => t(link.title),
    mobileTitle: (link) => (link.mobileTitle ? t(link.mobileTitle) : ''),
    imgAlt: (link) => (link.imgAlt ? t(link.imgAlt) : ''),
    route: (link) => {
      if (!link?.route) return undefined;
      if (link.isExternal) return link.route;
      if (link.route.startsWith('/') || link.route.startsWith('http')) {
        return link.route;
      }
      return t(link.route);
    },
  };
};
